import { Theme } from '@amzn/awsui-components-core/theming';

/**
 * Central font family constant — resolves via CSS custom property
 * defined in src/styles/_typography.scss (:root --font-family-base).
 * The actual font stack is defined once in SCSS — this just references it.
 */
export const FONT_FAMILY_BASE = 'var(--font-family-base)';

export const APP_THEME: Theme = {
  tokens: {
    fontFamilyBase: FONT_FAMILY_BASE,
    // Primary button color override: maps the primary button background to Cloudscape's
    // default blue (the same color used for normal button borders) instead of the default orange.
    // Token aliases generated via the Cloudscape theme editor (seed: #0099ff).
    // Reference export kept at docs/design/cloudscape-theme.json.
    colorBackgroundButtonPrimaryDefault: '{colorBorderButtonNormalDefault}',
    colorBackgroundButtonPrimaryActive: '{colorBorderButtonNormalActive}',
    colorBackgroundButtonPrimaryHover: '{colorBorderButtonNormalHover}',
    colorTextButtonPrimaryDefault: '{colorTextInverted}',
    colorTextButtonPrimaryActive: '{colorTextInverted}',
    colorTextButtonPrimaryHover: '{colorTextInverted}'
  }
};
